import Service from "./Service";
import {isEmpty} from 'lodash';
const baseurl = '/api/ingreso-vacunas';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    async index(search = '',pagination = {}) {
        let url = `${baseurl}?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url);
    },
    imprimir(id){
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/imprimir/${id}`
    },
}
